import Main from "../Main/Main";
import { G_elements } from "../utils/globals/elements";
import Group from "./Group";
import getAttributes from "./utils/get-attributes";
import processAttributes from "./utils/process-attributes";
import processGroupDataset from "./utils/process-group-dataset";

/**
 * Initializes the Main object
 * @this {GroupClassProps}
 * @returns {GroupClassProps}
 */
Group.prototype.init = function () {
  /** Dataset `data-tor` */
  const dataset = this.element.dataset.torGroup || "";

  /** Remove spaces */
  this.dataset = processGroupDataset(dataset);

  /** Get target and attributes */
  this.attributes = getAttributes(this, this.dataset);

  this.targets = processAttributes(this, this.attributes);

  /** Add element with reference to `this` into the global map */
  G_elements.set(this.element, this);

  Main.init(this.targets);

  /** Return class */
  return this;
}

export default Group.init;